import { render, staticRenderFns } from "./FormBoxContentsRowItem.vue?vue&type=template&id=36084084&scoped=true"
import script from "./FormBoxContentsRowItem.vue?vue&type=script&lang=js"
export * from "./FormBoxContentsRowItem.vue?vue&type=script&lang=js"
import style0 from "./FormBoxContentsRowItem.vue?vue&type=style&index=0&id=36084084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36084084",
  null
  
)

export default component.exports